<template>
  <v-hover v-slot="{ hover }">
    <v-card
      tile
      class="project-viewer-grid-item"
      :elevation="hover ? 16 : 2"
      :class="{ 'on-hover': hover }"
      v-if="workData"
      @click="handleClick"
    >
      <v-img
        :src="thumbnailURL"
        height="180"
        width="300"
        class="project-viewer-grid-item__image"
      >
        <template v-slot:placeholder>
          <v-row class="fill-height" align="center" justify="center">
            <v-img
              :src="StamenLogo"
              height="200"
              width="180"
              class="project-viewer-grid-item__image"
            >
            </v-img>
          </v-row>
        </template>
      </v-img>

      <v-container class="project-viewer-grid-item__text-container">
        <div>
          <div class="project-viewer-grid-item__date">{{ goLiveDate }}</div>

          <h6 class="project-viewer-grid-item__title">{{ cardTitle }}</h6>
          <div class="project-viewer-grid-item__company subtitle-1">
            {{ companyName }}
          </div>
        </div>
        <div
          class="project-viewer-grid-item__status overline"
          :style="{ color: postStatusColor }"
        >
          {{ postStatus }}
        </div>
      </v-container>
    </v-card>
  </v-hover>
</template>

<script>
// vuex
// library
// internal
import StamenLogo from '@/assets/img/Stamen.png'
// components
export default {
  props: {
    workData: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      StamenLogo,
      postStatusInfos: {
        publish: {
          text: 'published',
          color: 'green'
        },
        private: {
          text: 'private',
          color: 'red'
        },
        draft: {
          text: 'draft',
          color: 'orange' // change these to better colors
        }
      }
    }
  },
  methods: {
    handleClick() {
      // this.$router.push(`/projects/${this.workData.ID}`)
      this.$router.push(`/projects/${this.workData.['post_name']}`)
    }
  },
  computed: {
    cardTitle() {
      return this.workData['post_title']
    },
    thumbnailURL() {
      return this.workData['thumbnail_image']
        ? this.workData['thumbnail_image']
        : ''
    },
    companyName() {
      return this.workData['client']
    },
    goLiveDate() {
      return this.workData['go_live_date']
    },
    postStatus() {
      return this.postStatusInfos[this.workData['post_status']].text
    },
    postStatusColor() {
      return this.postStatusInfos[this.workData['post_status']].color
    }
  }
}
</script>

<style lang="scss" scoped>
.project-viewer-grid-item {
  display: flex;
  flex-flow: column;
  width: 230px;
  max-height: 390px;
  margin: 0px 10px 20px 10px;

  &__text-container {
    // border: 1px solid red;
    height: 100%;
    display: flex;
    flex-flow: column;
    justify-content: space-between;
  }

  &__image {
    border-bottom: 1px solid #aaaaaa;
  }

  &__company {
    color: #666666;
  }

  &__title {
    font-size: 1.3em;
  }

  &__date {
    // font-size: 0.9em;
    color: #949494;
  }

  @media only screen and (min-width: 2000px) {
    .project-viewer-grid-item {
      margin: 20px;
    }
  }
}
</style>
